import {
  mdiAccountMultipleOutline,
  mdiArrowCollapseDown,
  mdiBallot,
  mdiBriefcaseAccount,
  mdiCardTextOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiFileDocumentEditOutline,
  mdiRocketLaunchOutline,
  mdiUmbrellaOutline,
} from '@mdi/js'

import localStorageSlim from 'localstorage-slim'

const userProfile = localStorageSlim.get('userProfile', { decrypt: true })
const hierarchicalProfile = userProfile?.hierarchical_profile
const exceptionRoles = ['Administrativo', 'Administrador', 'Recursos Humanos', 'Auditoria', 'Central de Relacionamento',
  'Supervisor', 'Controladoria', 'Marketing', 'Pós-venda', 'Vendedor', 'Consorcio Administrativo', 'Semi Novos', 'Financeiro', 'Cobrança']

const personalDepartment = [
  {
    subheader: 'Departamento Pessoal',
  },

  // {
  //   title: 'Vales',
  //   icon: mdiTicketAccount,
  //   children: [
  //     {
  //       title: 'Registrar | Acompanhar',
  //       to: 'personal-department-home',
  //       ActiveTabColor: '#0BC000',
  //       ActiveTabColor2: '#42aa3c',
  //       hidden: false,
  //       icon: mdiTicketConfirmation,
  //     },
  //   ],
  // },
  {
    title: 'DP',
    icon: mdiBriefcaseAccount,
    children: [],
  },
]

if (userProfile) {
  const profile = userProfile.profile?.profile
  const occupationProfile = userProfile.occupation_sector?.occupation?.name

  if (occupationProfile === 'ANALISTA DE REMUNERAÇÃO') {
    personalDepartment.push({
      title: 'Controladoria',
      icon: mdiBallot,
      children: [
        {
          title: 'Conferencia Folha',
          icon: mdiCardTextOutline,
          to: 'report-sheet',
          hidden: true,
          ActiveTabColor: '#0BC000',
          ActiveTabColor2: '#42aa3c',
        },
      ],
    })
  }

  if (profile === 'Diretor') {
    personalDepartment.push({
      title: 'FÉRIAS',
      icon: mdiUmbrellaOutline,
      children: [
        {
          title: 'Gestão Férias',
          to: 'personal-department-vacation-management',
          icon: '',
          ActiveTabColor: '#0BC000',
          ActiveTabColor2: '#42aa3c',
        },
      ],
    })
  }

  if (hierarchicalProfile === 'nivel_2' && profile !== 'Departamento Pessoal') {
    // personalDepartment[2]?.children.unshift({
    //   title: 'Digitação Folha',
    //   to: 'personal-department-sheetTyping',
    //   icon: mdiFileDocumentEditOutline,
    //   ActiveTabColor: '#0BC000',
    //   ActiveTabColor2: '#42aa3c',
    // })

    personalDepartment.push({
      title: 'EXPORTAÇÕES',
      icon: mdiArrowCollapseDown,
      children: [
        {
          title: 'Exportação Folha',
          to: 'personal-department-export-commissions',
          icon: '',
          ActiveTabColor: '#0BC000',
          ActiveTabColor2: '#42aa3c',
        },
      ],
    })
  }

  if (hierarchicalProfile === 'nivel_2' && exceptionRoles.includes(profile)) {
    personalDepartment.push({
      title: 'FÉRIAS',
      icon: mdiUmbrellaOutline,
      children: [
        {
          title: 'Gestão Férias',
          to: 'personal-department-vacation-management',
          icon: '',
          ActiveTabColor: '#0BC000',
          ActiveTabColor2: '#42aa3c',
        },
      ],
    })
  }

  if (hierarchicalProfile === 'nivel_2') {
    personalDepartment.push({
      title: 'DIGITAÇÃO FOLHA',
      to: 'personal-department-sheetTyping',
      icon: mdiFileDocumentEditOutline,
      ActiveTabColor: '#0BC000',
      ActiveTabColor2: '#42aa3c',
    })
  }

  if (profile === 'Departamento Pessoal') {
    personalDepartment.push(
      {
        title: 'EXPORTAÇÕES',
        icon: mdiArrowCollapseDown,
        children: [
          {
            title: 'Exportação Vales',
            to: 'personal-department-dp',
            icon: '',
            ActiveTabColor: '#0BC000',
            ActiveTabColor2: '#42aa3c',
          },
          {
            title: 'Exportação Folha',
            to: 'personal-department-export-commissions',
            icon: '',
            ActiveTabColor: '#0BC000',
            ActiveTabColor2: '#42aa3c',
          },
        ],
      },
    )
    personalDepartment.push({
      title: 'FÉRIAS',
      icon: mdiUmbrellaOutline,
      children: [
        {
          title: 'Gestão de férias',
          to: 'personal-department-vacation-management',
          icon: '',
          ActiveTabColor: '#0BC000',
          ActiveTabColor2: '#42aa3c',
        },
        {
          title: 'Feriado',
          to: 'personal-department-register-holiday',
          icon: '',
          ActiveTabColor: '#0BC000',
          ActiveTabColor2: '#42aa3c',
        },
        {
          title: 'Restrições de férias',
          to: 'personal-department-vacation-restriction',
          icon: '',
          ActiveTabColor: '#0BC000',
          ActiveTabColor2: '#42aa3c',
        },
        {
          title: 'Importações',
          to: 'personal-department-import-holiday',
          icon: '',
          ActiveTabColor: '#0BC000',
          ActiveTabColor2: '#42aa3c',
        },
      ],
    })
    personalDepartment.push(
      {
        title: 'FUNCIONÁRIOS',
        to: 'users-dp',
        icon: mdiAccountMultipleOutline,
        ActiveTabColor: '#0BC000',
        ActiveTabColor2: '#42aa3c',
      },
      {
        title: 'FICHA FINANCEIRA',
        to: 'financial-statement',
        icon: mdiCurrencyUsd,
        ActiveTabColor: '#0BC000',
        ActiveTabColor2: '#42aa3c',
      },
      {
        title: 'LANÇAMENTOS',
        to: 'personal-department-dp-now',
        icon: mdiRocketLaunchOutline,
        ActiveTabColor: '#0BC000',
        ActiveTabColor2: '#42aa3c',
      },
    )
    personalDepartment.push(
      {
        title: 'FERRAMENTAS',
        icon: mdiCogOutline,
        children: [
          {
            title: 'Eventos',
            to: 'personal-department-dp-events',
            icon: '',
            ActiveTabColor: '#0BC000',
            ActiveTabColor2: '#42aa3c',
          },
          {
            title: 'Vales',
            to: 'personal-department-dp-types',
            icon: '',
            ActiveTabColor: '#0BC000',
            ActiveTabColor2: '#42aa3c',
          },
          {
            title: 'Ocupação / Função',
            to: 'personal-department-occupation',
            icon: '',
            ActiveTabColor: '#0BC000',
            ActiveTabColor2: '#42aa3c',
          },
          {
            title: 'Setor',
            to: 'personal-department-sector',
            icon: '',
            ActiveTabColor: '#0BC000',
            ActiveTabColor2: '#42aa3c',
          },
        ],
      },
    )
  }

  if (profile === 'Recursos Humanos') {
    personalDepartment.push(
      {
        title: 'FICHA FINANCEIRA',
        to: 'financial-statement',
        icon: mdiCurrencyUsd,
        ActiveTabColor: '#0BC000',
        ActiveTabColor2: '#42aa3c',
      },
      {
        title: 'FUNCIONÁRIOS',
        to: 'users-dp',
        icon: mdiAccountMultipleOutline,
        ActiveTabColor: '#0BC000',
        ActiveTabColor2: '#42aa3c',
      },
    )
  }
}

export default personalDepartment
